import React from "react";
import LoginForm from "../../component/LoginComponent/LoginForm";
import Footer from "../../component/Footer/Footer";

function Login() {
    return (
        <div className="LoginConatiner">
            <div className="loginMainParent">
                <LoginForm />
            </div>
            <div className="footer_div">
                <Footer />
            </div>
        </div>

    )
}
export default Login;